// extracted by mini-css-extract-plugin
export var bold = "heading-module--bold--8872d";
export var bolder = "heading-module--bolder--ae647";
export var h1 = "heading-module--h1--a789c";
export var h2 = "heading-module--h2--eccd3";
export var h3 = "heading-module--h3--10c3a";
export var h4 = "heading-module--h4--3fddf";
export var h5 = "heading-module--h5--eacc2";
export var h6 = "heading-module--h6--df5a2";
export var heading = "heading-module--heading--dfbbf";
export var normal = "heading-module--normal--22744";